import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { DownloadedFile } from '../../redux/Attachment/Attachment.type';
import InputComponent, {
  StyledInput,
  StyledInputContainer,
  StyledInputDescription,
  StyledInputLabel,
} from './Input.component';
import ButtonComponent from '../Button.component';
import IconButtonComponent from '../IconButton.component';
import TrashIcon from '../Icons/Trash.icon';

export interface FileProps {
  label?: React.ReactNode;
  placeholder?: string;
  value?: File | DownloadedFile;
  onChange: Function;
  disabled?: boolean;
  accept?: string[];
  validationFailureMessage?: string;
}

const StyledInputOverride = styled(StyledInput)`
  display: none;
`;
const StyledFileWrapper = styled.div``;

const FileComponent = ({
  label,
  placeholder,
  value,
  onChange,
  disabled = false,
  accept = [],
  validationFailureMessage
}: FileProps) => {
  const hiddenInputFile = useRef<HTMLInputElement | null>(null);
  const [file, setFile] = useState<File | DownloadedFile>();
  const { t } = useTranslation();

  useEffect(() => {
    if (value) {
      setFile(value);
    }
  }, [value]);

  const handleSetFile = (fileRaw: File) => {
    setFile(fileRaw);
    onChange(fileRaw);
  };

  const clearFile = () => {
    setFile(undefined);
    onChange(undefined);
    // @ts-ignore
    hiddenInputFile.current.form.reset();
  };

  const renderButton = useMemo(() => {
    return file ? (
      <InputComponent
        readonly
        value={file.name}
        right={
          <IconButtonComponent onClick={clearFile}>
            <TrashIcon />
          </IconButtonComponent>
        }
      />
    ) : (
      <ButtonComponent
        // @ts-ignore
        handleClick={() => hiddenInputFile.current.click()}
        disabled={disabled}
      >
        {t('Choose file')}
      </ButtonComponent>
    );
  }, [hiddenInputFile, file, disabled]);

  return (
    <StyledFileWrapper>
      <StyledInputContainer>
        {label && <StyledInputLabel>{label}</StyledInputLabel>}
        <StyledInputOverride
          ref={hiddenInputFile}
          type="file"
          accept={accept?.join(',')}
          disabled={disabled}
          onChange={({ target }: any) => handleSetFile(target.files[0])}
          placeholder={placeholder}
        />
        {renderButton}

        {validationFailureMessage && (
          <StyledInputDescription>{validationFailureMessage}</StyledInputDescription>
        )}
      </StyledInputContainer>
    </StyledFileWrapper>
  );
};

export default FileComponent;
